//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import brandPickerMenuItemTemplate from '@legacy-components/settings-menu/brand-picker-menu-item/brand-picker-menu-item.html';

import _ from "js/underscore-mixins";

(function() {
  const unison = angular.module('unison');

  unison.component('brandPickerMenuItem', {
    template: brandPickerMenuItemTemplate,
    require: {
      dropdownCtrl: '^^cuPopover',
    },
    controller: [
      'SessionVarsService',
      'TrackingService',
      function(
                SessionVarsService,
                TrackingService,
            ) {
        this.$onInit = function() {
          this.groupName = SessionVarsService.getGroupName();
          this.brandName = SessionVarsService.getClientName();
          this.submenuActive = false;

          // Filter removes Like2BuyMobile groups that fill up client switcher
          this.groups = SessionVarsService.getGroupsAndBrands().filter(
            group =>
              group.id === crl8.session.group.id ||
              !group.brands.every(brand => brand.clientType === 'Like2Buy'),
          );

          if (SessionVarsService.getHideGroups()) {
            this.groups = _.filter(this.groups, group => group.id === SessionVarsService.getGroup().id);
          }

          this.sortedItemIds = this.groups.map(group => group.id);
          this.typeaheadValues = this.groups.map(group => group.name);
        };

        this.changeClient = function(brand) {
          TrackingService.recordEvent(
                        TrackingService.CATEGORY_NAVIGATION3,
                        TrackingService.ACTION_NAVIGATION3_BRAND_CHANGE,
                        `${brand.name}-${brand.id}`,
                    );

          SessionVarsService.changeClient(brand.id);
          this.dropdownCtrl.close();
        };

        this.setIsSubmenuActive = ($status) => {
          this.submenuActive = $status === 'open';
        };
      }],
  });
})();
